import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calculator } from "lucide-react";

const ParkingBarrierSystems = ({ onBack }) => {
  const navigate = useNavigate();

  const modules = [
    {
      id: 'parking-barriers',
      title: 'Parking Barriers',
      subtitle: '(Basic Barrier Systems)',
      icon: Calculator,
      color: 'from-orange-600 to-yellow-600',
      hoverColor: 'hover:from-orange-700 hover:to-yellow-700',
      navigate: '/parking-barriers',
      available: true
    },
    {
      id: 'advanced-parking',
      title: 'Advanced Parking Solutions',
      subtitle: '(Car park & paid parking management)',
      icon: Calculator,
      color: 'from-emerald-500 to-teal-600',
      hoverColor: 'hover:from-emerald-600 hover:to-teal-700',
      navigate: '/advanced-parking',
      available: false
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-8">
      <div className="max-w-5xl mx-auto">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={onBack}
          className="mb-6 text-slate-600 hover:text-slate-900"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>

        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <img src="/zkteco-logo.png" alt="ZKTeco" className="h-24 w-auto" />
          </div>
          <h1 className="text-3xl font-bold text-slate-800 mb-2">
            Parking Barrier Systems
          </h1>
          <p className="text-lg text-slate-600">
            Select a configurator to get started
          </p>
        </div>

        {/* Modules Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {modules.map((module) => {
            const Icon = module.icon;
            return (
              <button
                key={module.id}
                onClick={() => module.available && navigate(module.navigate)}
                className={`group relative overflow-hidden ${!module.available ? 'cursor-not-allowed' : ''}`}
                disabled={!module.available}
                data-testid={`${module.id}-card`}
              >
                <Card className={`border-2 border-slate-200 ${module.available ? 'hover:border-green-500' : 'opacity-75'} transition-all duration-300 h-56`}>
                  <CardContent className="p-0 h-full">
                    <div className={`h-full bg-gradient-to-br ${module.color} ${module.available ? module.hoverColor : ''} transition-all duration-300 flex flex-col items-center justify-center text-white relative overflow-hidden`}>
                      {/* Coming Soon Badge */}
                      {!module.available && (
                        <div className="absolute top-4 right-4 z-20">
                          <div className="px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-xs font-semibold">
                            Coming Soon
                          </div>
                        </div>
                      )}
                      
                      {/* Icon */}
                      <div className="relative z-10 mb-4">
                        <div className="w-16 h-16 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          <Icon className="h-8 w-8" />
                        </div>
                      </div>
                      
                      {/* Title */}
                      <h3 className="relative z-10 text-xl font-bold mb-1 text-center px-4">{module.title}</h3>
                      {module.subtitle && (
                        <p className="relative z-10 text-sm text-white/80 text-center px-4">{module.subtitle}</p>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ParkingBarrierSystems;
